/**
 * Fields for Template to render document
 */
export enum ReportDocumentTemplateFields {
  Id = "_id",
  AccountId = "AccountId",
  ContentType = "ContentType",
  CreatedDate = "createdDate",
  Description = "description",
  EntityId = "entityId",
  FlowId = "flowId",
  Inputs = "Inputs",
  IsActive = "isActive",
  LastActor = "LastActor",
  LastModifiedOn = "LastModifiedOn",
  Name = "name",
  ObjectStatusId = "objectStatusId",
  StoredProcedures = "StoredProcedures",
  Template = "Template"
}
